<template >
  <van-popup
    position="bottom"
    round
    closeable
    @close="closeModal"
    class="select-zhubu-modal"
    :style="{ 'height': '80%','overflow':'hidden'}"
    v-model="modalShow"
  >
  <div class="tit">点击选择定制主布</div>
   <div class="list">
       <van-empty v-if="list.length==0">没有数据</van-empty>
       <div @click="selectItem(item)" :class="['item',{'active':item.active}]" :key="item.id" v-for="item in list">
         <img  :src="item.colorImageUrl"/>
         <span class="title">{{item.number}}</span>
      </div>
   </div>
   <van-button @click="confirmSelectZhuBuAction" color="#f24749" type="primary" block>确认选择</van-button>
  </van-popup>
</template>
<script >
export default {
  props: {

    list:{
     type:Array,
      required: true,
      default: false,
    },
    modalShow: {
      type: Boolean,
      required: true,
      default: false,
    },
  },

  data() {
    return {};
  },
  mounted() {},
  methods : {
    confirmSelectZhuBuAction(){
    this.$emit('confirmSelectZhuBuAction',false);
    },
    closeModal(){
       this.$emit('setSelectZhubuModal',false);
    },
    selectItem(item){

      this.$emit('selectZhubu',item);
    }
  }
};
</script >
<style scoped>
.select-zhubu-modal .tit{
        text-align: center;
    position: absolute;
    padding-top: 15px;
    width: 100%;
}
.select-zhubu-modal .list{
          display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -ms-flex-line-pack: start;
    align-content: flex-start;
       margin-top: 60px;
    height: calc(90vh - 104px);
    overflow-y: auto;
    padding-bottom: 40px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
 .select-zhubu-modal .list .item{
        margin-bottom: 20px;
    padding: 10px;
    max-height: calc(50vw - 15px);
    overflow: hidden;
    position: relative;
    box-sizing: border-box;
    border: 1px solid #f0494e59;
 }

  .select-zhubu-modal .list .item img{
   max-width: 100%;
 }
 .select-zhubu-modal .list .title{
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
    left: 0;
    background: #f1f1f1c4;
    padding: 5px;
 }
 .select-zhubu-modal .list .active .title{
   background: #3a3a3ab0!important;
   color:#ffff
 }
</style>
